import axios from "axios";
import i18n from "@/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 45000,
});

function currentLang() {
  return (i18n.language || "fr").split("-")[0];
}

export async function fetchReferenceData() {
  const { data } = await api.get("/reference-data", { params: { lang: currentLang() } });
  return data;
}

export async function fetchConfig() {
  const { data } = await api.get("/config");
  return data;
}

export async function fetchPreview(inputs) {
  const { data } = await api.post("/preview", { inputs, lang: currentLang() });
  return data;
}

export async function submitStudy({ inputs, lead }) {
  const { data } = await api.post("/submit", { inputs, lead, lang: currentLang() });
  return data;
}

export async function fetchResume(token) {
  const { data } = await api.get(`/resume/${encodeURIComponent(token)}`);
  return data;
}

export async function downloadPdf({ inputs, lead }) {
  const res = await api.post("/pdf", { inputs, lead, lang: currentLang() }, { responseType: "blob" });
  return res.data;
}
